module.exports = __webpack_public_path__ + "static/navyhat-b583b6489e6e81c47aab482cce6451fe.jpeg";